// extracted by mini-css-extract-plugin
export default {"ButtonOrange":"ButtonOrange_ButtonOrange__3s-PX"};